import React from 'react';  
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Image from 'react-bootstrap/Image';
//import Button from 'react-bootstrap/Button';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { connect } from 'react-redux'
import { ACT_LOGOUT, ACT_LOGGING, ACT_REPORT_HOLIDAYS, ACT_REPORT_DISTANCE, ACT_REPORT_LOGGING, ACT_REPORT_TIMESHEET, ACT_REPORT_SUMMARY, ACT_REPORT_ADV, ACT_HELP } from './actions.js';
import { LogOut } from './msal'
const reportMenus=['holidayreport','distancereport','logreport','timesheetreport','summaryreport','advreport']

class Menu extends React.Component {  

	

	render() {  

		let showShowSummaryReportMenu = (this.props.jobDayInfo !== undefined && this.props.jobDayInfo.length>0)

		let navbarmenu =
			<>
				<Navbar.Toggle aria-controls="basic-navbar-nav" />
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="mr-auto" style={{ fontSize: "20px" }}>
						<Nav.Link onClick={() => { this.props.log() }} active={this.props.menu==='logging'}>Log</Nav.Link>
						<NavDropdown title="Reports" id="basic-nav-dropdown" active={reportMenus.includes(this.props.menu)}>
							<NavDropdown.Item onClick={() => { this.props.holidayReport() }} active={this.props.menu === 'holidayreport'}>Holiday report</NavDropdown.Item>
							<NavDropdown.Item onClick={() => { this.props.distanceReport() }} active={this.props.menu === 'distancereport'}>Compensation report</NavDropdown.Item>
							<NavDropdown.Item onClick={() => { this.props.logReport() }} active={this.props.menu === 'logreport'}>Log report</NavDropdown.Item>
							<NavDropdown.Divider />
							<NavDropdown.Item onClick={() => { this.props.timeSheetReport() }} active={this.props.menu === 'timesheetreport'}>Experts Timesheet</NavDropdown.Item>
							{showShowSummaryReportMenu && <NavDropdown.Item onClick={() => { this.props.summaryReport() }} active={this.props.menu === 'summaryreport'}>Summary report</NavDropdown.Item>}
							{/*<NavDropdown.Item onClick={()=>{this.props.ADVReport()}}>ADV</NavDropdown.Item>*/}
						</NavDropdown>
						
						<Nav.Link onClick={() => { this.props.logout() }} active={this.props.menu === ''}>Log out ({this.props.userInfo["code"]})</Nav.Link>
						<Nav.Link onClick={() => { this.props.help() }} active={this.props.menu === 'help'}><Image src="help.png" width={"32px"}/></Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</>

		if (this.props.state===false) navbarmenu=''
		
		return (
			<Navbar style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)'}}  expand="md"  >
				<Navbar.Brand>
					<img alt="" src="1127-DEKGROUPmobile-TRANSP.png" height="40" className="d-inline-block align-top"/>
				</Navbar.Brand>
				{navbarmenu}
			</Navbar> 
			);  
	}  
} 

function mapStateToProps(state) {
    //console.log("menu: state changed:" + JSON.stringify(state.user))
	return { userInfo: state.user.userInfo, menu: state.menu.menu, jobDayInfo: state.user.jobDayInfo}
}

function mapDispatchToProps(dispatch) {
    return {
        logout: async () => {
			//console.log("logout")
			await LogOut();
            dispatch({ type: ACT_LOGOUT })
        },
		log: () => {
            //console.log("log")
            dispatch({ type: ACT_LOGGING })
        },
		holidayReport: () => {
            //console.log("holiday report")
            dispatch({ type: ACT_REPORT_HOLIDAYS })
        },
		distanceReport: () => {
            //console.log("distance report")
            dispatch({ type: ACT_REPORT_DISTANCE })
        },
		logReport: () => {
            //console.log("log report")
            dispatch({ type: ACT_REPORT_LOGGING })
        },
		timeSheetReport: () => {
            //console.log("log report")
            dispatch({ type: ACT_REPORT_TIMESHEET })
		},
		summaryReport: () => {
			//console.log("summary report")
			dispatch({ type: ACT_REPORT_SUMMARY })
		},
		ADVReport: () => {
            //console.log("log report")
            dispatch({ type: ACT_REPORT_ADV })
		},
		help: () => {
			dispatch({ type: ACT_HELP })
		}
    }

}


  
export default connect(mapStateToProps, mapDispatchToProps)(Menu);  